module.exports = __webpack_public_path__ + "img/top_44.f583f9c5.png";